export function initJourneyTop(){
    const journey = document.querySelector<HTMLElement>('.journey-items');
    const button = document.querySelector<HTMLElement>('.journey-top');
    const header = document.querySelector<HTMLElement>('header');

    if (journey && button) {
        const updateButton = () => {
            const rect = journey.getBoundingClientRect();
            const windowHeight = window.innerHeight;

            const headerHeight = header?.offsetHeight || 0;

            // 👇 центр экрана с учётом хедера
            const triggerPoint = (windowHeight / 2) + headerHeight;

            const isVisible =
                rect.top < -triggerPoint &&
                rect.bottom > triggerPoint;

            button.classList.toggle('show', isVisible);

            // 👉 позиция по X (справа от блока)
            const offsetX = 20;
            const journeyRight = rect.right;

            const maxRight = window.innerWidth - button.offsetWidth - 16;
            const left = Math.min(journeyRight + offsetX, maxRight);

            button.style.left = `${left}px`;

            // 👉 позиция по Y (центр экрана + хедер)
            let top = windowHeight / 2 + headerHeight / 2;

            // ограничение внутри блока
            const minTop = rect.top + headerHeight + 40;
            const maxTop = rect.bottom - 40;

            if (top < minTop) top = minTop;
            if (top > maxTop) top = maxTop;

            button.style.top = `${top}px`;
            button.style.transform = 'translateY(-50%)';
        };

        let ticking = false;

        const onScroll = () => {
            if (!ticking) {
                requestAnimationFrame(() => {
                    updateButton();
                    ticking = false;
                });
                ticking = true;
            }
        };

        window.addEventListener('scroll', onScroll);
        window.addEventListener('resize', updateButton);

        // 👉 плавный скролл с учётом header
        button.addEventListener('click', () => {
            const headerHeight = header?.offsetHeight || 0;

            const top =
                journey.getBoundingClientRect().top +
                window.scrollY -
                headerHeight;

            window.scrollTo({
                top,
                behavior: 'smooth'
            });
        });

        updateButton();
    }

}